export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3001';
export const COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID || '';
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID || '';
export const COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION || 'ap-south-1';
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN || '';

export const getCognitoHostedUIUrl = (state: string): string => {
  const redirectUri = encodeURIComponent(`${FRONTEND_URL}/auth/callback`);
  const scope = encodeURIComponent('openid email');
  return `https://${COGNITO_DOMAIN}/login?` +
    `client_id=${COGNITO_CLIENT_ID}&` +
    `response_type=code&` +
    `scope=${scope}&` +
    `redirect_uri=${redirectUri}&` +
    `state=${state}`;
};

